/**
 * Prototype switches for the Sylvia / Teri workflow review.
 */

/**
 * Required-field validation. When on, Continue checks the page and lists what is missing, and the
 * progress bar / section tabs cannot jump ahead of an incomplete step. Set to false to click through
 * every screen freely (e.g. for a quick workflow walkthrough); completion percentages work either way.
 */
export const ENFORCE_REQUIRED_FIELDS = true

/**
 * "Accounting contact responsible for taxes being paid" — may be hidden if State Reports is live in
 * the portal at rollout (communication then happens in the portal instead of by email).
 */
export const SHOW_TAX_PAYMENT_CONTACT = true

/** Design manual p.3: the Onboarding Checklist Assistant stays active for 30 days. */
export const ONBOARDING_SESSION_DAYS = 30
